<template>
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <!--        <img class="mx-auto h-12 w-auto" src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg" alt="Workflow">-->
        <!--        <div>-->
        <!--            <svg xmlns="http://www.w3.org/2000/svg" class="text-indigo-900 dark:text-white h-16 w-16 mx-auto mb-4 w-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">-->
        <!--                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />-->
        <!--                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />-->
        <!--            </svg>-->
        <!--        </div>-->
        <slot />
        <h2 class="mt-10 text-center text-gray-900 dark:text-white font-display text-2xl font-bold">
            <slot name="title" />
        </h2>
        <p v-show="hasLink" class="mt-0 text-center text-gray-900 dark:text-slate-300 font-display text-lg">
            or
            <slot name="link" />
        </p>
    </div>
</template>

<script>
export default {
    computed: {
        hasLink() {
            return !!this.$slots.link
        },
    },
}
</script>
